import React, { PropsWithChildren } from 'react';
import SRError from '~/utils/errors/srError';

const DebugContext = React.createContext<boolean | undefined>(undefined);

export interface ISERPBrowserDebugTools {
    countFulltextResults: (indexName: string) => number;
}

const browserDebugTools = (): ISERPBrowserDebugTools => {
    if (typeof window === 'undefined') {
        throw new SRError('window is not defined');
    }

    return {
        countFulltextResults: () => {
            const fulltextResultsContainer = document.querySelector('.serp-fulltext-results-container');
            if (fulltextResultsContainer === null) {
                throw new SRError('fulltextResultsContainer is null');
            }
            return fulltextResultsContainer.childNodes.length;
        },
    };
};

/**
 * Provides DebugContext.
 *
 * @returns wrapped children components
 */
export const DebugProvider: React.FC<PropsWithChildren<{ debug: boolean }>> = ({ debug, children }) => {
    if (debug) {
        window.serpDebugTools = browserDebugTools();
    }
    return <DebugContext.Provider value={debug}>{children}</DebugContext.Provider>;
};

/**
 * Hook for accessing DebugContext.
 */
export const useDebug = () => {
    const context = React.useContext(DebugContext);
    if (context === undefined) {
        throw new SRError('useDebug must be used within a DebugProvider');
    }

    return context;
};
